// extracted by mini-css-extract-plugin
export default {"img":"carousel_img__RKWgW"};